const atcForm = document.querySelector('form[action="/cart/add"]');
const atcButton = document.querySelector('.product-form--atc-button');
if (atcButton) {
  atcButton.addEventListener('click', (event) => {
    event.preventDefault();    
    addItemToCart();
  });
}

// Variant selection functionality
document.addEventListener('DOMContentLoaded', () => {
  initVariantSelectors();
});

function initVariantSelectors() {
  const productForm = document.querySelector('[data-product-form]');
  if (!productForm) return;

  // Get product JSON from the script tag
  const productJsonScript = document.querySelector('[data-section-type="static-product"][data-section-data]');
  if (!productJsonScript) return;

  try {
    const productData = JSON.parse(productJsonScript.textContent);
    const product = productData.product;
    const variants = product.variants;

    // Find all option selectors (both dropdowns and radio buttons)
    const optionSelectors = productForm.querySelectorAll('[data-product-option]');
    
    // Add change event listeners to all option selectors
    optionSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        updateSelectedVariant(productForm, product, variants, productData);
      });
    });

    // Initialize with the current selection
    updateSelectedVariant(productForm, product, variants, productData);
  } catch (error) {
    console.error('Error initializing variant selectors:', error);
  }
}

$(document).ready(function(){

    $(document).on('change','.product-optionsg-1 select',function(){
      getSecondOptions();
    })
    function getSecondOptions(){
  var url = window.location.href;
  console.log(url)
  $.ajax({
    url: url+'&section_id=product-template',   // URL jahan se data lena hai
    type: 'GET',
    success: function(response) {
      var sectionOptions = $(response).find('.product-optionsg-2 select').html();
      if( sectionOptions == undefined ){
          sectionOptions = $(response).filter('.product-optionsg-2 select').html();
      }
      $(document).find('.product-optionsg-2 select').html(sectionOptions);
      setTimeout(function(){
        var $firstAvailable = $(document).find('.product-optionsg-2 select').find('option.avail').first();

          if ($firstAvailable.length) {
            $(document).find('.product-optionsg-2 select').val($firstAvailable.val()).trigger('change');
             const productForm = document.querySelector('[data-product-form]');
              if (!productForm) return;
            
              // Get product JSON from the script tag
              const productJsonScript = document.querySelector('[data-section-type="static-product"][data-section-data]');
              if (!productJsonScript) return;
            const productData = JSON.parse(productJsonScript.textContent);
            const product = productData.product;
            const variants = product.variants;
            updateSelectedVariant(productForm, product, variants, productData)
          }
      },100)
    },
    error: function(xhr, status, error) {
      console.error('Error:', error);
    }
  });
}
    
  })



function updateSelectedVariant(form, product, variants, productData) {
  // Get the currently selected options
  const selectedOptions = [];
  const optionSelectors = form.querySelectorAll('[data-product-option]');
  
  optionSelectors.forEach(selector => {
    const optionIndex = parseInt(selector.getAttribute('data-product-option'), 10);
    
    // Handle both select dropdowns and radio buttons
    let optionValue;
    if (selector.tagName === 'SELECT') {
      optionValue = selector.value;
    } else if (selector.tagName === 'INPUT' && selector.type === 'radio' && selector.checked) {
      optionValue = selector.value;
    }
    
    if (optionValue) {
      selectedOptions[optionIndex] = optionValue;
    }
  });

  // Make sure all options are selected
  if (selectedOptions.length === product.options.length && !selectedOptions.includes(undefined)) {
    // Find the matching variant
    const matchingVariant = variants.find(variant => {
      return product.options.every((option, index) => {
        return variant.options[index] === selectedOptions[index];
      });
    });

    if (matchingVariant) {
      // Update the variant ID input/select
      const variantIdElement = form.querySelector('input[name="id"], select[name="id"]');
      if (variantIdElement) {
        variantIdElement.value = matchingVariant.id;
      }

      // Update price - try multiple selectors to find the price element
      const priceSelectors = [
        '.atc-info--price',
        '.product__price',
        '[data-product-price]',
        '.product-price'
      ];
      
      let priceElement = null;
      for (const selector of priceSelectors) {
        const element = document.querySelector(selector);
        if (element) {
          priceElement = element;
          break;
        }
      }
      
      if (priceElement && matchingVariant.price) {
        // Format price according to Shopify's money format
        const moneyFormat = productData?.settings?.money_format || "${{amount}}";
        const formattedPrice = formatMoney(matchingVariant.price, moneyFormat);
        
        // Log for debugging
        console.log('Updating price to:', formattedPrice);
        
        // Update the price element
        priceElement.innerHTML = formattedPrice;
      } else {
        console.log('Price element not found or variant has no price');
      }

      // Update stock level text
      const stockLevelText = document.querySelector('.stock-level--text');
      if (stockLevelText) {
        console.log('Variant inventory status:', {
          title: matchingVariant.title,
          available: matchingVariant.available,
          inventory_quantity: matchingVariant.inventory_quantity,
          inventory_policy: matchingVariant.inventory_policy
        });
        
        // Get the parent element that contains both the icon and text
        const stockLevelWrapper = stockLevelText.closest('.product--stock-level') || 
                                  stockLevelText.closest('.stock-level--wrapper');
        
        if (stockLevelWrapper) {
          // First, remove all stock-related classes to start fresh
          stockLevelWrapper.classList.remove(
            'stock-level--in-stock', 
            'stock-level--low-stock', 
            'stock-level--no-stock',
            'stock-level--out-of-stock'
          );
          
          if (matchingVariant.available) {
            if (matchingVariant.inventory_quantity > 10) {
              stockLevelText.textContent = `${matchingVariant.inventory_quantity} In stock`;
              stockLevelWrapper.classList.add('stock-level--in-stock');
            } else if (matchingVariant.inventory_quantity > 0) {
              stockLevelText.textContent = `Only ${matchingVariant.inventory_quantity} left!`;
              stockLevelWrapper.classList.add('stock-level--low-stock');
            } else if (matchingVariant.inventory_policy === 'continue') {
              stockLevelText.textContent = 'Available for backorder';
              stockLevelWrapper.classList.add('stock-level--in-stock');
            } else {
              // Default in-stock message if we can't determine specifics
              stockLevelText.textContent = 'In stock';
              stockLevelWrapper.classList.add('stock-level--in-stock');
            }
          } else {
            stockLevelText.textContent = 'Sold out';
            stockLevelWrapper.classList.add('stock-level--no-stock');
          }
          
          // Remove any custom styling we added previously
          if (document.getElementById('stock-level-styles')) {
            document.getElementById('stock-level-styles').remove();
          }
        } else {
          console.log('Stock level wrapper not found');
        }
        
        console.log('Updated stock level text for variant:', matchingVariant.title, 'to:', stockLevelText.textContent);
      }

      // Update availability
      const atcButton = form.querySelector('.product-form--atc-button');
      const atcButtonText = atcButton?.querySelector('.atc-button--text');
      
      if (atcButton && atcButtonText) {
        if (matchingVariant.available) {
          atcButton.classList.remove('disabled');
          atcButton.removeAttribute('disabled');
          atcButtonText.textContent = window.theme?.translations?.addToCart || 'Add to cart';
        } else {
          atcButton.classList.add('disabled');
          atcButton.setAttribute('disabled', 'disabled');
          atcButtonText.textContent = window.theme?.translations?.soldOut || 'Sold out';
        }
      }

      // Update SKU if displayed
      const skuElement = document.querySelector('[data-product-sku]');
      if (skuElement && matchingVariant.sku) {
        skuElement.textContent = matchingVariant.sku;
      }

      // Update URL with variant ID if history enabled
      if (productData?.settings?.enableHistory) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchingVariant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  let value = '';

  const match = formatString.match(placeholderRegex);
  if (match) {
    const type = match[1];
    switch (type) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

async function getShopifyCartItemQty() {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const cartData = await response.json();
    let totalQuantity = 0;
    for (let item of cartData.items) {
      return item.quantity;        
    }

    return totalQuantity;
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}

function toggleAtcSpinner(show) {
  const atcBtn = document.querySelector('.product-form--atc-button');
  if (show) {
    atcBtn.classList.add('processing');
    atcBtn.setAttribute('disabled', 'disabled');
  }
  else {
    atcBtn.classList.remove('processing');
    atcBtn.removeAttribute('disabled');
  }
}

function showErrorMessage(message) {
  const siteHeader = document.querySelector('header.site-header');
  siteHeader.insertAdjacentHTML('beforeend',
    `<div class="message-banner--container message--error visible" role="alert" data-message-banner="">
      <div class="message-banner--outer">
        <div class="message-banner--inner" data-message-banner-content="">${message}</div>
        <button class="message-banner--close" type="button" aria-label="Close" data-message-banner-close="">      
          <svg class="icon-menu-close " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">          <title>Close icon</title>        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 7.73744L1.61872 12.6187L0.381283 11.3813L5.26256 6.50001L0.381283 1.61872L1.61872 0.381287L6.5 5.26257L11.3813 0.381287L12.6187 1.61872L7.73744 6.5L12.6187 11.3813L11.3813 12.6187L6.5 7.73744Z" fill="currentColor"></path>    </svg>                                                
        </button>
      </div>
    </div>`
  );
  // const errMsgContainer = document.querySelector('.message-banner--container');
  // const errMsgInner = errMsgContainer.querySelector('.message-banner--inner');
  // errMsgContainer.classList.add('message--error','visible');
  // errMsgInner.textContent = message;
}

async function updateCartIconQty() {
  const currentCartItemQty = await getShopifyCartItemQty();
  console.log('currentCartItemQty',currentCartItemQty);
  const cartCount = document.querySelector('.site-header-cart--count');
  cartCount.dataset.headerCartCount = currentCartItemQty;
}

function addItemToCart() {
  toggleAtcSpinner(true);
  const productIdElement = (document.querySelector('input[name="id"]')) ? document.querySelector('input[name="id"]') : document.querySelector('select[name="id"]');
  const productVariantId = parseInt(productIdElement.value);
  const quantity = parseInt(document.querySelector('input[name="quantity"]').value);    
  let formData = { 'items': [
      {
        'id': productVariantId,
        'quantity': quantity
      }
    ] };
    
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    console.log('add to cart success data', data);
    if (data.status >= 300) {
      showErrorMessage(data.message);
      updateCartIconQty();
    }
    else {
      window.location.href = '/cart';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    var response = JSON.parse(error.responseText);
    showErrorMessage(response.message);
  })
  .finally((response) => {
    toggleAtcSpinner(false);
  });
}

// Separate function to update stock level text that can be called by the MutationObserver
function updateStockLevelText(variant) {
  const stockLevelText = document.querySelector('.stock-level--text');
  if (!stockLevelText) return;
  
  console.log('Updating stock level for variant:', {
    title: variant.title,
    available: variant.available,
    inventory_quantity: variant.inventory_quantity,
    inventory_policy: variant.inventory_policy
  });
  
  // Get the parent element that contains both the icon and text
  const stockLevelWrapper = stockLevelText.closest('.product--stock-level') || 
                            stockLevelText.closest('.stock-level--wrapper');
  
  if (stockLevelWrapper) {
    // First, remove all stock-related classes to start fresh
    stockLevelWrapper.classList.remove(
      'stock-level--in-stock', 
      'stock-level--low-stock', 
      'stock-level--no-stock',
      'stock-level--out-of-stock'
    );
    
    if (variant.available) {
      // Check if inventory_quantity is defined and valid
      const hasInventoryCount = typeof variant.inventory_quantity === 'number' && !isNaN(variant.inventory_quantity);
      
      if (hasInventoryCount && variant.inventory_quantity > 10) {
        // Instead of just changing the text content, use a more robust approach
        // 1. Create a custom element to show the inventory count
        const inventoryCountSpan = document.createElement('span');
        inventoryCountSpan.className = 'inventory-count';
        inventoryCountSpan.textContent = variant.inventory_quantity + ' ';
        
        // 2. Clear the stock level text and add our custom element first
        stockLevelText.textContent = '';
        stockLevelText.appendChild(inventoryCountSpan);
        
        // 3. Add the "In stock" text after our count
        const stockTextNode = document.createTextNode('In stock');
        stockLevelText.appendChild(stockTextNode);
        
        // 4. Add appropriate class
        stockLevelWrapper.classList.add('stock-level--in-stock');
        
        // 5. Store the inventory count for reference
        stockLevelWrapper.setAttribute('data-inventory-count', variant.inventory_quantity);
      } else if (hasInventoryCount && variant.inventory_quantity > 0) {
        // For low stock, use the same approach
        const inventoryCountSpan = document.createElement('span');
        inventoryCountSpan.className = 'inventory-count';
        inventoryCountSpan.textContent = 'Only ' + variant.inventory_quantity + ' ';
        
        stockLevelText.textContent = '';
        stockLevelText.appendChild(inventoryCountSpan);
        
        const stockTextNode = document.createTextNode('left!');
        stockLevelText.appendChild(stockTextNode);
        
        stockLevelWrapper.classList.add('stock-level--low-stock');
        stockLevelWrapper.setAttribute('data-inventory-count', variant.inventory_quantity);
      } else if (variant.inventory_policy === 'continue') {
        stockLevelText.textContent = 'Available for backorder';
        stockLevelWrapper.classList.add('stock-level--in-stock');
        stockLevelWrapper.removeAttribute('data-inventory-count');
      } else {
        // Default in-stock message if we can't determine specifics or inventory count is not available
        stockLevelText.textContent = 'In stock';
        stockLevelWrapper.classList.add('stock-level--in-stock');
        stockLevelWrapper.removeAttribute('data-inventory-count');
      }
      
      // Add CSS to ensure our inventory count is always visible
      let styleEl = document.getElementById('inventory-count-styles');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'inventory-count-styles';
        document.head.appendChild(styleEl);
      }
      
      styleEl.textContent = `
        .inventory-count {
          display: inline !important;
          visibility: visible !important;
          opacity: 1 !important;
        }
      `;
    } else {
      stockLevelText.textContent = 'Sold out';
      stockLevelWrapper.classList.add('stock-level--no-stock');
      stockLevelWrapper.removeAttribute('data-inventory-count');
    }
    
    // Remove any old custom styling we added previously
    if (document.getElementById('stock-level-styles')) {
      document.getElementById('stock-level-styles').remove();
    }
  } else {
    console.log('Stock level wrapper not found');
  }
  
  console.log('Updated stock level text for variant:', variant.title, 'to:', stockLevelText.textContent);
}


$(document).ready(function(){
  $(document).on('click','.boost-sd__button--quick-view',function(){
    var parent = $(this).closest('.boost-sd__product-item'),
        url = $(parent).find('.boost-sd__product-link').attr('href');
      
      //console.log(url);
      $.get(url, function(data) {
        var infor = $(data).find('.metafield-description-table').html();
        var infromHt = '<table class="metafield-description-table">'+infor+'</table>';
        //console.log(infor)
        var pricePer =  '<span class="price-per pdp">'+$(data).find('.price-per.pdp').html()+'</span>';

        $('#boost-sd__modal-quickview').find('.boost-sd__quick-view-price').after(pricePer+infromHt);
    });
  })

});


// Set up a MutationObserver to watch for changes to the stock level text
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const stockLevelText = document.querySelector('.stock-level--text');
    if (stockLevelText && window.MutationObserver) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'characterData' || mutation.type === 'childList') {
            // If we have a current variant and the text was changed by something else
            if (window.currentSelectedVariant) {
              console.log('Stock level text was changed externally, reapplying our formatting');
              
              // Check if the text was changed to just "In stock" but we have an inventory count
              const inventoryCount = stockLevelText.getAttribute('data-inventory-count');
              if (stockLevelText.textContent === 'In stock' && inventoryCount) {
                stockLevelText.textContent = `${inventoryCount} In stock`;
              } else {
                // Otherwise do a full update
                updateStockLevelText(window.currentSelectedVariant);
              }
            }
          }
        });
      });
      
      // Configure and start the observer
      observer.observe(stockLevelText, { 
        characterData: true, 
        childList: true,
        subtree: true 
      });
      
      console.log('Stock level text observer set up');
    }
  }, 1000); // Wait a second for other scripts to initialize
});

